import Phaser from 'phaser';
import { GameConfig } from './GameConfig';

export class Helper {
	private scene: Phaser.Scene;
	private centerX: number;
	private centerY: number;

	constructor(scene: Phaser.Scene) {
		const gameWidth: any = scene.cameras.main.centerX;
		const gameHeight: any = scene.cameras.main.centerY;
		this.scene = scene;
		this.centerX = gameWidth + GameConfig.boardOffSetX;
		this.centerY = gameHeight + GameConfig.boardOffSetY;
	}

	addSpriteLocPos(name, posX, posY) {
		return this.scene.add.sprite(this.centerX + posX, this.centerY + posY, name);
	}

	addBitmapText(text: string, font: string, size: number, align: number, posX: number, posY: number) {
		return this.scene.add.bitmapText(this.centerX + posX, this.centerY + posY, font, text, size, align);
	}

	addText(text: string, posX: number, posY: number, style?: object) {
		return this.scene.add.text(this.centerX + posX, this.centerY + posY, text, style);
	}

	tweenPosition(o, x, y) {
		this.scene.tweens.add({
			targets: [o],
			x: x,
			y: y,
			duration: 500,
			ease: 'Sine.inOut'
		});
	}

	toDegrees(angle) {
		return angle * (180 / Math.PI);
	}

	randomIntFromInterval(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}
}
